import React, { Component } from 'react';

import classNames from 'classnames';
import { Select } from 'components/input/select';
import { I18n, translate } from 'components/translate';
import PropTypes from 'prop-types';

import { VALUES_PER_PAGE } from './constants';

import './Pagination.scss';

const initialPageZeroBased = 0;

@translate()
export default class Pagination extends Component {
  // #region set up
  static propTypes = {
    changePage: PropTypes.func,
    changePerPage: PropTypes.func,
    className: PropTypes.string,
    currentPage: PropTypes.number,
    numberOfElements: PropTypes.number,
    perPage: PropTypes.number,
    showCurrentRange: PropTypes.bool,
    t: PropTypes.func,
    totalRegisters: PropTypes.number
  };

  static defaultProps = {
    currentPage: 0,
    numberOfElements: 0,
    perPage: VALUES_PER_PAGE.TEN,
    showCurrentRange: false,
    totalRegisters: 0
  };
  // #endregion

  constructor(props) {
    super(props);

    this.moveForward = this.moveForward.bind(this);
    this.moveBackward = this.moveBackward.bind(this);
  }

  // #region helpers
  get perPageValues() {
    return Object.values(VALUES_PER_PAGE).map((perPageItem) => ({
      label: perPageItem,
      value: perPageItem
    }));
  }

  get arrayPagination() {
    const { totalRegisters, perPage } = this.props;

    const length = Math.ceil(totalRegisters / perPage);
    const pages = [];

    for (let index = 0; index < length; index++) {
      pages.push({
        value: index,
        label: index + 1
      });
    }

    return pages;
  }

  get reducedPagination() {
    const pages = this.arrayPagination;
    const { currentPage } = this.props;
    const length = pages.length;
    const limit = 6;
    const prevLimit = limit - 1;

    if (length > limit) {
      if (currentPage - prevLimit + 1 > 0) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        let last = currentPage - 3;
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        let ellipsisValue = currentPage - 3;

        if (currentPage + prevLimit > length) {
          last = length - limit;
          ellipsisValue = length - prevLimit - 1;
        }

        pages.splice(1, last, { value: ellipsisValue, label: '...' });
      }

      if (currentPage + prevLimit <= length) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        let lastValue = currentPage + 3;

        if (currentPage - prevLimit <= 0) {
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          lastValue = prevLimit + 2;
        }

        pages.splice(
          prevLimit,
          length - prevLimit,
          { value: lastValue, label: '...' },
          { value: length - 1, label: length }
        );
      }
    }

    return pages;
  }

  get currentRange() {
    const { currentPage, perPage, numberOfElements, totalRegisters } =
      this.props;
    const rangeStart = currentPage * perPage + 1;
    const rangeEnd = currentPage * perPage + numberOfElements;

    return `${rangeStart} - ${rangeEnd} ${this.props.t(
      'general.of'
    )} ${totalRegisters}`;
  }
  // #endregion

  // #region handlers
  changePage = (page) => {
    const { currentPage, changePage } = this.props;

    if (
      page >= 0 &&
      page < this.arrayPagination.length &&
      page !== currentPage
    ) {
      changePage && changePage(page);
    }
  };

  changePerPage = (select) => {
    const { perPage, changePerPage } = this.props;

    if (select.value !== perPage) {
      changePerPage && changePerPage(select.value);
    }
  };

  moveForward() {
    const { currentPage } = this.props;

    this.changePage(currentPage + 1);
  }

  moveBackward() {
    const { currentPage } = this.props;

    this.changePage(currentPage - 1);
  }
  // #endregion

  // #region render
  renderPerPage() {
    const { perPage } = this.props;

    return (
      <div className="pagination__select">
        <label>
          <I18n label="pagination.registers_per_page" />
        </label>

        <Select
          name="class"
          isClearable={false}
          value={{ label: perPage, value: perPage }}
          options={this.perPageValues}
          onChange={this.changePerPage}
        />
      </div>
    );
  }

  renderPagination() {
    const { currentPage, showCurrentRange } = this.props;
    const pages = this.arrayPagination;
    const reducedPages = this.reducedPagination;
    const previousClass = classNames('previous', {
      disabled: currentPage === initialPageZeroBased
    });
    const nextClass = classNames('next', {
      disabled: currentPage === pages.length - 1
    });

    return (
      <div className="pagination">
        {showCurrentRange && (
          <label className="current__range">{this.currentRange}</label>
        )}

        <nav>
          <ul>
            <li className={previousClass} onClick={this.moveBackward} />

            {reducedPages.map((page, index) => {
              if (page) {
                return (
                  <li
                    key={index}
                    onClick={() => this.changePage(page.value)}
                    className={currentPage === page.value ? 'active' : ''}
                  >
                    {page.label}
                  </li>
                );
              }

              return null;
            })}

            <li className={nextClass} onClick={this.moveForward} />
          </ul>
        </nav>
      </div>
    );
  }

  render() {
    const { changePerPage, className } = this.props;

    const classComponent = classNames('pagination__wrapper', className);

    return (
      <div className={classComponent}>
        {changePerPage && this.renderPerPage()}
        {this.renderPagination()}
      </div>
    );
  }
  // #endregion
}
